import { useSearchParams } from 'react-router-dom';

import { IS_DEV_ENV } from 'shared/constants';

/**
 * Returns `true` when the app is running in standalone mode (URL parameter `host` is not `revit` and ENVIRONMENT is `Local` or `Dev`)
 */

export const useIsStandaloneMode = (): boolean => {
    const [searchParams] = useSearchParams();
    return IS_DEV_ENV && searchParams.get('host') !== 'revit';
};
